import React from 'react';
import { Trans } from 'react-i18next';
import { withState } from 'recompose'
import styled from 'styled-components';
import i18next from 'i18next';

import { PageTitleRedS, WhiteCardS } from '../adminLayout/adminCommonStyles';
import AdminProfileForm from '../../forms/adminProfileForm';
import { LightBtnS, Text } from '../../common';
import ChangePassModal from '../../modals/changePass';

const PassWrapperS = styled.div`
  margin: 40px 0 20px;
`;

const AdminProfileComponent = ({
  changePassModalState,
  setChangePassModalState
}) => (
  <>
    <ChangePassModal // maybe later will rewriten this modal
      isModalOpen={changePassModalState}
      toggleModal={setChangePassModalState}
      isAdmin
    />

    <PageTitleRedS>
      <Trans i18nKey="adminPanel.profile.pageTitle" />
    </PageTitleRedS>

    <WhiteCardS>

    <AdminProfileForm />

    <PassWrapperS>
      <Text color="darkerViolet" >{i18next.t('adminPanel.profile.passwordCapture')}</Text>
    </PassWrapperS>
    <LightBtnS color="violet" onClick={() => setChangePassModalState(true)}>
      {i18next.t('adminPanel.profile.changePassBtn')}
    </LightBtnS>

    </WhiteCardS>
  </>
);

export default withState('changePassModalState', 'setChangePassModalState', false)(AdminProfileComponent);